import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import useUserProfileFetcher from '../hooks/useUserProfileFetcher'
import { UserProfileDto } from '../types/UserProfileDto'

import UserDetail from './UserDetail'

const UserDetailPage: React.FC = () => {
  // Extracting id parameter from the route
  const { id } = useParams<{ id: string }>()
  const [userProfile, setUserProfile] = useState<UserProfileDto>()
  const { fetchUserProfileDetail, errorUserProfile } = useUserProfileFetcher()
  useEffect(() => {
    if (!id) {
      return // Exit early if `id` is undefined
    }

    const fetchDataAsync = async () => {
      const data = await fetchUserProfileDetail(id)

      if (!data) {
        return
      }

      setUserProfile(data)
    }

    void fetchDataAsync()
  }, [])

  return (
    <>
      {userProfile && <UserDetail userProfile={userProfile} />}

      <div>{errorUserProfile?.message}</div>
    </>
  )
}

export default UserDetailPage
